import request from '@/router/axios';

export const getList = (current, size, params, search) => {
    return request({
        url: '/api/blade-loanCredentialManagement/loanCredentialManagement/page',
        method: 'post',
        data: {
            ...params,
            ...search,
            current,
            size
        }
    })
}

export const remove = (id) => {
    return request({
        url: '/api/blade-loanStorageLocationManagement/loanStorageLocationManagement/remove',
        method: 'post',
        data: {
            id,
        }
    })
}

export const add = (row) => {
    return request({
        url: '/api/blade-loanStorageLocationManagement/loanStorageLocationManagement/submit',
        method: 'post',
        data: row
    })
}

export const update = (row) => {
    return request({
        url: '/api/blade-loanCredentialManagement/loanCredentialManagement/update',
        method: 'post',
        data: row
    })
}

export const updateBond = (row) => {
    return request({
        url: '/api/blade-loanSecurityDept/loanSecurityDept/updateSecurity',
        method: 'post',
        data: row
    })
}


export const exportData = (data) => {
    return request({
        url: `/api/blade-loanSecurityDept/loanSecurityDept/export-loanSecurityDept`,
        method: "post",
        responseType: 'blob',
        data: data,
    });
}

// 批量入库
export const bePutInStorageBatch = (row) => {
  return request({
      url: '/api/blade-loanCredentialManagement/loanCredentialManagement/bePutInStorageBatch',
      method: 'post',
      data: row
  })
}

// 入库
export const bePutInStorage = (row) => {
  return request({
      url: '/api/blade-loanCredentialManagement/loanCredentialManagement/bePutInStorage',
      method: 'post',
      data: row
  })
}

// 换库
export const changeStorageSubmit = (row) => {
  return request({
      url: '/api/blade-loanStorageLocationManagement/loanStorageLocationManagement/change-storage/submit',
      method: 'post',
      data: row
  })
}

// 修改数量
export const editPutInStorage = (row) => {
  return request({
      url: '/api/blade-loanCredentialManagement/loanCredentialManagement/editPutInStorage',
      method: 'post',
      data: row
  })
}

// 手动入库
export const addCredentialManagement = (row) => {
  return request({
      url: '/api/blade-loanCredentialManagement/loanCredentialManagement/addCredentialManagement',
      method: 'post',
      data: row
  })
}
// 手动入库
export const getLoanInfomationByCode = (row) => {
  return request({
      url: '/api/blade-loanInformation/loanInformation/getLoanInfomationByCode',
      method: 'post',
      data: row
  })
}
